import { getToken } from '../utils/cookieUtils';

// import "../CSS File/SubscriptionSummary.css";

// import React, {useEffect, useState} from 'react';
// import { IoMdStopwatch } from "react-icons/io";
// import { MdOutlineAttachMoney } from "react-icons/md";
// import { TfiTimer } from "react-icons/tfi";
// import chatBubble from "../images/icons/chatBubble.png";
// import profile from '../images/Vector.jpg';
// import smile from "../images/smile.svg"
// import { useNavigate } from 'react-router-dom';

// const SubscriptionSummary = (props) => {
// debugger

//   // Pricing is as per the Service Address Zip Code  red color

//   const [content, setdPlans] = useState([]);
//   const [postalCode, setPostalCode] = useState(null);
//   const [address, setAddress] = useState(null);
//     const [PlanList, setPlans] = useState([]);
//     const [PLanDetails,SetPlanData]=useState([]);
//     const [planName,setPlanName]=useState("");
//     const [openaddDialog, setOpenaddDialog] = useState(false);
//     const [openDialog, setOpenDialog] = useState(false);
//     const [imageDialog, setimageDialog] = useState(false);
//     const [isHovered, setIsHovered] = useState(false);
//     const [isApiSuccess, setIsApiSuccess] = useState(false); // Track if API call succeeded
//     const [loading, setLoading] = useState(true);
    
    
//     const handleButtonClick = (Option, chefOption) => {
      
//       EnterOrderDetail(chefOption.subscribe_chef_id);
     
//     };

//     const AddSubscription = () => {
//       navigate("/subscription-plans");
//     };

//   let navigate = useNavigate();


//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         await Promise.all([
//           UserDetails(),
//           routeTosignIn(),
//           checksubcription(),
//           SubscriptionPlan()
//         ]);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [planName]);



  
//     const checksubcription = async () => {
//       try {
//         let response = await fetch(
//           `${process.env.REACT_APP_BASE_URL}subscription/check_current_plan`,
//           {
//             method: "POST",
//             headers: {
//               Authorization: "Bearer " + getToken(),
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               user_id: `${localStorage.getItem("logged_user_id")}`,
//                 "postal_code": `${localStorage.getItem("postalCode")}`
//             }),
//           }
//         );
//         const res_json = await response.text();
//         const CurrentPlan = JSON.parse(res_json);

//         if (CurrentPlan.status === true) {
//           console.log(CurrentPlan);
//           SetPlanData(CurrentPlan);
//           setIsApiSuccess(true);
//         } else {
//           setIsApiSuccess(false); // Handle error
//           console.error("Error: Response status is false");
//         }
//       } catch (error) {
//         console.error("Error while fetching data, please try later:", error);
//       }
//     };
//     let SubscriptionPlan = async () => {
//       try {
//         let response = await fetch(
//           `${process.env.REACT_APP_BASE_URL}subscription/fetch_subscription_chef`,
//           {
//             method: "POST",
//             headers: {
//               Authorization: "Bearer " + getToken(),
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({  
//               user_id: `${localStorage.getItem("logged_user_id")}`,
//             }),
//           }
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         let responseData = await response.json();
//         console.log(responseData);
//         if (responseData) {
//           console.log(responseData);
//           setPlans(responseData);
//           setIsApiSuccess(true);
//         } else {
//           setIsApiSuccess(false); 
//           console.error("Error: Response status is false");
//         }
//       } 
//       catch (error) {
//         console.error("Error fetching subscription data:", error);
//       }
     
     
//     };
  
//  const UserDetails = async () => {
  
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BASE_URL}user/loggedin_customer_detail`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: "Bearer " + getToken(),
//           },
//         }
//       );
//       const res_json = await response.text();
//       const userDetails = JSON.parse(res_json);

//       if (userDetails.status === true) {
        
//         const fetchedPostalCode = userDetails.data[0].postal_code; // Extract and store postalcode
//         const fetchedAddress = userDetails.data[0].customer_address; // Extract and store address

//         console.log("Postal Code:", fetchedPostalCode);
//         console.log("Address:", fetchedAddress);

//         // Store in state variables
//         setPostalCode(fetchedPostalCode);
//         setAddress(fetchedAddress);
//         setIsApiSuccess(true);
//       } else {
//         setIsApiSuccess(false);
//         console.error("Error: Response status is false");
//       }
//     } catch (error) {
//       console.error("Error while fetching data, please try later:", error);
//     }
//   };

//   const cancelSubscription = async () => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BASE_URL}subscription/cancel_subscription_plan`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: "Bearer " + getToken(),
//             "Content-Type": "application/json",   
//           },
//           body: JSON.stringify({
//             user_id: localStorage.getItem("logged_user_id"),
//           }),
//         }
//       );
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const res_json = await response.text();
//       const data = JSON.parse(res_json);

//       if (data.status === true) {
//         // Perform actions after successful subscription cancellation
//         localStorage.removeItem("subscription_id");
//         // Store postalCode and address in localStorage
//         if (postalCode) localStorage.setItem("postalCode", postalCode);
//         if (address) localStorage.setItem("address", address);

//         setPlanName(data.messages); // Set the plan name
//         console.log("Subscription canceled successfully!");
//       } else {
//         console.error("Error while canceling the subscription.");
//       }
//     } catch (error) {
//       console.error("Error occurred:", error);
//     }
//   };
//     let cancelConfirmationSubscription = async () => {
//       setOpenDialog(!openDialog);
//     };

  
    

//     const changeScreen = () => {
//       cancelSubscription();
//       setOpenDialog(false);
//       setPlanName("");
//       setimageDialog(true);
//     };
//     const changeScreenSecondButton = () => {
//       navigate("/subscription-plans");
//     };

//     const handleNavigate = () => {
//       navigate("/chef-list");
//     };

//     const EnterOrderDetail = (chef_id) => {
//       localStorage.setItem("chef_id", chef_id);
//       navigate("/booking-detail");
//     };

//     const routeTosignIn = async () => {
//       if((localStorage.getItem("role"))){
//         console.log('display Play List');
//       }else{
//         navigate("/sign-in");
//       }
//     };
  
//     return (
//       <>

//         {
//           <div className="container">
//             <p className="mt-2 mb-0 text-center">Subscription Summary</p>

//             {loading ? (
//               <div className="text-center mt-5 py-5">
//                 <div className="spinner-border text-orange" role="status">
//                   <span className="visually-hidden">Loading...</span>
//                 </div>
//                 <p className="mt-2">Loading subscriptions...</p>
//               </div>
//             ) : PlanList.length > 0 ? (
//               <>
//                 <div className="mobile new-design-card mt-3">
//                   <div
//                     style={{
//                       display: !PLanDetails.chef_status ? "block" : "none",
//                     }}
//                   >
//                     <div
//                       style={{
//                         paddingTop: "5px",
//                         display: "flex",
//                         justifyContent: "flex-end",
//                       }}
//                     >
//                       <p
//                         role="button"
//                         style={{
//                           whiteSpace: "pre-wrap",
//                           textAlign: "center",
//                           marginTop: "7px",
//                           marginBottom: "3px",
//                           marginRight: "6px",
//                           color: "#ff5e41",
//                           cursor: "pointer",
//                           fontSize: "0.9rem",
//                         }}
//                         onClick={() => AddSubscription()}
//                       >
//                         + Select Pricing
//                       </p>
//                     </div>
//                   </div>
//                   <div className="row">
//                     {PlanList.map((option, index) => (
//                       <div className="col-md-4 col-sm-12" key={index}>
//                         <div
//                           className="border row border-1 m-1 py-2"
//                           style={{
//                             borderRadius: "20px",
//                             boxShadow: "0 0 0 rgba(0,0,0,0.2)", // Corrected boxShadow syntax
//                           }}
//                         >
//                           <div className="row">
//                             <div>
//                               <span
//                                 className="badge text-wrap"
//                                 style={{
//                                   borderRadius: "20px",
//                                   color: "white",
//                                   backgroundColor:
//                                     option.status === "Active"
//                                       ? "#4dff4d"
//                                       : "red", // Simplified the static backgroundColor
//                                 }}
//                               >
//                                 {option.status}
//                               </span>

//                               <span
//                                 className="badge text-wrap"
//                                 style={{
//                                   borderRadius: "20px",
//                                   marginLeft: "10px",
//                                   color: "white",
//                                   backgroundColor: `${option.color_code}`,
//                                 }}
//                               >
//                                 {option.plan_name}
//                               </span>
//                             </div>

//                             <div className="row my-2">
//                               <p className="pl-4 mb-0">
//                                 Subscription ID: {option.subscription_no}
//                               </p>
//                             </div>
//                             {option.chef.map((chefData, ChefIndex) => (
//                               <div className="chef-new-card" key={ChefIndex}>
//                                 <div className="row">
//                                   <div className="col-md-2 col-2">
//                                     <div
//                                       className="d-flex justify-content-center align-items-center my-2"
//                                       style={{
//                                         width: "50px",
//                                         height: "50px",
//                                         borderRadius: "50%",
//                                       }}
//                                     >
//                                       <img
//                                         src={
//                                           chefData.booking_by_user_profile_image
//                                             ? chefData.booking_by_user_profile_image
//                                             : profile
//                                         }
//                                         style={{
//                                           width: "50px",
//                                           height: "50px",
//                                           borderRadius: "50%",
//                                         }}
//                                         alt="Profile"
//                                       />
//                                     </div>
//                                   </div>
//                                   <div className="col-md-10 col-10 d-flex align-items-center">
//                                     <h6 className="fw-bold">
//                                       {chefData.chef_name}
//                                     </h6>
//                                   </div>
//                                 </div>

//                                 <div className="row">
//                                   <div className="col-md-2 col-2">
//                                     <button
//                                       style={{
//                                         width: "50px",
//                                         height: "50px",
//                                         borderRadius: "50%",
//                                         border: "1px solid #FF5E41",
//                                         cursor: "pointer",
//                                         backgroundColor: "#FF5E41",
//                                       }}
//                                       className="px-1"
//                                       onClick={() => {
//                                         console.log(option.chef.length);
//                                         navigate("/subscription-message", {
//                                           state: {
//                                             data: {
//                                               plan_id: option.plan_id,
//                                               plan_name: option.plan_name,
//                                               color_code: option.color_code,
//                                               image: chefData.profile_image,
//                                               name: chefData.chef_name,
//                                               subscription_status:
//                                                 chefData.status,
//                                               customer_id: chefData.user_id,
//                                               chef_id:
//                                                 chefData.subscribe_chef_id,
//                                             },
//                                           },
//                                         });
//                                       }}
//                                     >
//                                       <img
//                                         src={chatBubble}
//                                         className="img-fluid"
//                                         alt=""
//                                       />
//                                     </button>
//                                   </div>
//                                   <div className="col-md-10 col-10">
//                                     <div className="row my-2">
//                                       <div className="col-1">
//                                         <p className="p-0 mb-0">
//                                           <IoMdStopwatch
//                                             style={{
//                                               fontSize: "1.2rem",
//                                             }}
//                                           />
//                                         </p>
//                                       </div>
//                                       <div className="col-10">
//                                         <p
//                                           className="p-0 m-0"
//                                           style={{ fontSize: "0.9rem" }}
//                                         >
//                                           Every {chefData.timeslot}
//                                         </p>
//                                       </div>
//                                     </div>
//                                     <div className="row my-2">
//                                       <div className="col-1">
//                                         <p className="p-0 mb-0">
//                                           <MdOutlineAttachMoney
//                                             style={{ fontSize: "1.2rem" }}
//                                           />
//                                         </p>
//                                       </div>
//                                       <div className="col-10 text-break">
//                                         <p
//                                           className="mb-0"
//                                           style={{
//                                             fontSize: "0.9rem",
//                                             paddingTop: "0.1rem",
//                                           }}
//                                         >
//                                           {chefData.price}
//                                         </p>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>

//                                 <div className="button-container">
//                                   <div style={{ position: "relative" }}>
//                                     <button
//                                       className="px-1 container-button"
//                                       style={{
//                                         width: "140px",
//                                         fontSize: "0.7rem",
//                                         pointerEvents:
//                                         option?.enter_order_details === true
//                                           ? false // Enabled when true
//                                           : true // Disabled when null, undefined, or false
//                                           ? "none"
//                                           : "auto",
//                                       opacity:
//                                         option?.enter_order_details === true
//                                           ? false // Enabled when true
//                                           : true // Disabled when null, undefined, or false
//                                           ? 0.6
//                                           : 1,
//                                       }}
//                                       onClick={() => {
//                                         localStorage.setItem(
//                                           "subscription_id",
//                                           chefData.subscription_id
//                                         );
//                                         handleButtonClick(
//                                           option.chef,
//                                           chefData
//                                         );
//                                       }}
//                                       disabled={
//                                         option?.enter_order_details === true
//                                           ? false // Enabled when true
//                                           : true // Disabled when null, undefined, or false
//                                       }

                                    
//                                     >
//                                       Enter Order Details
//                                     </button>
//                                   </div>

                    
//                                 </div>
//                                 {ChefIndex < option.chef.length - 1 && (
//                                   <hr style={{ marginBottom: "5px" }} />
//                                 )}
//                               </div>
//                             ))}
//                             {option.status === "Active" &&
//                               option.max_dates > option.chef.length && (
//                                 <div className="select one more day text-center">
//                                   <p
//                                     role="button"
//                                     onClick={() => handleNavigate()}
//                                     style={{
//                                       whiteSpace: "pre-wrap",
//                                       textAlign: "center",
//                                       marginTop: "7px",
//                                       marginBottom: "3px",
//                                       marginRight: "6px",
//                                       color: "#ff5e41",
//                                       cursor: "pointer",
//                                       fontSize: "0.7rem",
//                                     }}
//                                   >
//                                     + Select One More Day For The Week
//                                   </p>
                               
//                                 </div>

//                               )}
//                           </div>
//                         </div>

//                         <div>
//                           {option.status === "Active" &&
//                             option.min_dates > option.chef.length && (
//                               <div
//                                 style={{
//                                   color: "#FF5E41",
//                                   marginBottom: "5px",
//                                   marginLeft: "10px",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <span style={{ fontSize: "0.55rem" }}>
//                                   {option.message}{" "}
//                                 </span>
//                               </div>
//                             )}
//                         </div>

//                         <div
//                           style={{
//                             paddingTop: "5px",
//                             textAlign: "center",
//                             display:
//                               option.status === "Active" ? " block" : "none",
//                           }}
//                         >
//                           <button
//                             className="px-1 container-button mb-3"
//                             style={{ width: "150px", fontSize: "0.7rem" }}
//                             onClick={() => cancelConfirmationSubscription()}
//                             disabled={
//                               option.status === "Inactive" ||
//                               option.min_dates > option.chef.length
//                             }
//                           >
//                             Cancel Subscription
//                           </button>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//                 <div className="App text-start">
//                   <div
//                     style={{
//                       display: !PLanDetails.chef_status ? "block" : "none",
//                     }}
//                   >
//                     <div
//                       style={{
//                         paddingTop: "5px",
//                         display: "flex",
//                         justifyContent: "flex-end",
//                       }}
//                     >
//                       <button
//                         className="px-1 container-button"
//                         style={{ width: "140px", fontSize: "0.7rem" }}
//                         onClick={() => AddSubscription()}
//                       >
//                         Select Pricing
//                       </button>
//                     </div>
//                   </div>

//                   {isApiSuccess &&
//                     PlanList.length > 0 &&
//                     PlanList.map((option, index) => (
//                       <div key={index} className="row my-2 ">
//                         <div
//                           className="p-3 "
//                           style={{
//                             borderRadius: "20px",
//                             border: "1px solid #dee2e6",
//                           }}
//                         >
//                           <div className="mb-3">
//                             <span style={{ marginRight: "20px" }}>
//                               Subscription ID: {option.subscription_no}{" "}
//                             </span>
//                             <span
//                               className="badge "
//                               style={{
//                                 borderRadius: "20px",
//                                 color: "white",
//                                 backgroundColor:
//                                   option.status === "Active"
//                                     ? "#4dff4d"
//                                     : "red", // Simplified the static backgroundColor
//                               }}
//                             >
//                               {option.status}
//                             </span>
//                             <span
//                               className="badge"
//                               style={{
//                                 borderRadius: "20px",
//                                 marginLeft: "10px",
//                                 color: "white",
//                                 backgroundColor: `${option.color_code}`, // Simplified the static backgroundColor
//                               }}
//                             >
//                               {option.plan_name}
//                             </span>
//                           </div>

//                           {option.chef.map((chefOption, chefIndex) => (
//                             <div
//                               key={chefIndex}
//                               className="row me-2 my-2"
//                               style={{
//                                 justifyContent: "start",
//                                 display: "flex",
//                               }}
//                             >
//                               <div
//                                 className="col-md-3"
//                                 style={{ borderRight: "2px solid black" }}
//                               >
//                                 <div className="chef-name">
//                                   <img
//                                     src={
//                                       chefOption.booking_by_user_profile_image
//                                         ? chefOption.booking_by_user_profile_image
//                                         : profile
//                                     }
//                                     style={{
//                                       width: "40px",
//                                       height: "40px",
//                                       borderRadius: "50%",
//                                       marginRight: "5px",
//                                     }}
//                                     alt="Profile"
//                                   />
//                                   <span>{chefOption.chef_name}</span>
//                                 </div>
//                               </div>
//                               <div className="col-md-4">
//                                 <div className="chef-time mt-2">
//                                   <TfiTimer size={20} />
//                                   <span className="ms-2">
//                                     Every {chefOption.timeslot}{" "}
//                                   </span>
//                                 </div>
//                               </div>
//                               <div className="col-md-4">
//                                 <div
//                                   className="row chef-button"
//                                   style={{ borderRight: "2px solid black" }}
//                                 >
//                                   <div className="col-md-10 text-center">
//                                     <button
//                                       className="px-1 container-button"
//                                       style={{
//                                         width: "140px",
//                                         fontSize: "0.7rem",

//                                         pointerEvents:
//                                           option?.enter_order_details === true
//                                             ? false // Enabled when true
//                                             : true // Disabled when null, undefined, or false
//                                             ? "none"
//                                             : "auto",
//                                         opacity:
//                                           option?.enter_order_details === true
//                                             ? false // Enabled when true
//                                             : true // Disabled when null, undefined, or false
//                                             ? 0.6
//                                             : 1,
//                                       }}
//                                       onClick={() => {
//                                         localStorage.setItem(
//                                           "subscription_id",
//                                           chefOption.subscription_id
//                                         );
//                                         handleButtonClick(
//                                           option.chef,
//                                           chefOption
//                                         );
//                                       }}
//                                       disabled={
//                                         option?.enter_order_details === true
//                                           ? false // Enabled when true
//                                           : true // Disabled when null, undefined, or false
//                                       }
//                                     >
//                                       Enter Order Details
//                                     </button>
//                                   </div>
                       
//                                   <div className="col-md-2">
//                                     <button
//                                       className="px-1 container-button"
//                                       onClick={() => {
//                                         console.log(option.chef.length);
//                                         navigate("/subscription-message", {
//                                           state: {
//                                             data: {
//                                               // status: option,
//                                               plan_id: option.plan_id,
//                                               plan_name: option.plan_name,
//                                               color_code: option.color_code,
//                                               image: chefOption.profile_image,
//                                               name: chefOption.chef_name,
//                                               subscription_status:
//                                                 chefOption.status,
//                                               customer_id: chefOption.user_id,
//                                               chef_id:
//                                                 chefOption.subscribe_chef_id,
//                                             },
//                                           },
//                                         });
//                                       }}
//                                     >
//                                       <img
//                                         src={chatBubble}
//                                         className="img-fluid"
//                                         alt=""
//                                       />
//                                     </button>
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="col-md-1">
//                                 <div
//                                   className="px-1 mt-2"
//                                   style={{
//                                     backgroundColor: "#FFFFFF",
//                                     color: "#000000",
//                                   }}
//                                 >
//                                   ${option.price}
//                                 </div>
//                               </div>
//                             </div>
//                           ))}
//                           <div className="below_button">
//                             {option.status === "Active" &&
//                               option.max_dates > option.chef.length && (
//                                 <div className="row text-center">
//                                   <div className="mb-3">
//                                     <button
//                                       className="px-2 container-button"
//                                       style={{ fontSize: "0.7rem" }}
//                                       onMouseEnter={() => setIsHovered(true)}
//                                       onMouseLeave={() => setIsHovered(false)}
//                                       onClick={() => handleNavigate()}
//                                     >
//                                       {isHovered ? (
//                                         <span style={{ fontSize: "0.7rem" }}>
//                                           + Select One More Day For The Week
//                                         </span>
//                                       ) : (
//                                         <span
//                                           className="px-3"
//                                           style={{ fontSize: "0.8rem" }}
//                                         >
//                                           +
//                                         </span>
//                                       )}
//                                     </button>
//                                   </div>
//                                 </div>
//                               )}
//                           </div>
//                         </div>
//                         <div>
//                           {option.status === "Active" &&
//                             option.min_dates > option.chef.length && (
//                               <div
//                                 style={{
//                                   color: "#FF5E41",
//                                   marginBottom: "5px",
//                                 }}
//                               >
//                                 <span
//                                   style={{
//                                     fontSize: "0.7rem",
//                                   }}
//                                 >
//                                   {option.message}{" "}
//                                 </span>
//                               </div>
//                             )}
//                         </div>
//                         <div
//                           style={{
//                             paddingTop: "5px",
//                             display:
//                               option.status === "Active" ? " block" : "none",
//                           }}
//                         >
//                           <button
//                             className="px-1 container-button"
//                             style={{ width: "140px", fontSize: "0.7rem" }}
//                             onClick={() => cancelConfirmationSubscription()}
//                           >
//                             Cancel Subscription
//                           </button>
//                         </div>
//                       </div>
//                     ))}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div
//                   style={{
//                     paddingTop: "5px",
//                     display: "flex",
//                     justifyContent: "flex-end",
//                   }}
//                 >
//                   <button
//                     className="px-1 container-button"
//                     style={{ width: "140px", fontSize: "0.7rem" }}
//                     onClick={() => AddSubscription()}
//                   >
//                     Select Pricing
//                   </button>
//                 </div>
//                 <div className="text-center mt-5">
//                   <p>You Do Not Have Any Subscriptions Yet</p>{" "}
//                   {/* Show if no plans after successful API */}
//                 </div>
//               </>
//             )}
//           </div>
//         }
//       </>
//     );
//   }
  
//   export default SubscriptionSummary;


import "../CSS File/SubscriptionSummary.css";
import React, {useEffect, useState} from 'react';
import DynamicDialog from './DynamicDialog';
import SubscriptionConsentDialog from './SubscriptionConsentDialog';
import { IoMdStopwatch } from "react-icons/io";
import { MdOutlineAttachMoney } from "react-icons/md";
import { TfiTimer } from "react-icons/tfi";
import chatBubble from "../images/icons/chatBubble.png";
import profile from '../images/Vector.jpg';
import smile from "../images/smile.svg"
import { useNavigate } from 'react-router-dom';

const SubscriptionSummary = (props) => {
  

  const [content, setdPlans] = useState([]);
  const [postalCode, setPostalCode] = useState(null);
  const [address, setAddress] = useState(null);
  const [PlanList, setPlans] = useState([]);
  const [PLanDetails,SetPlanData]=useState([]);
  const [planName,setPlanName]=useState("");
  const [openaddDialog, setOpenaddDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [imageDialog, setimageDialog] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isApiSuccess, setIsApiSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  
  // New states for popups using DynamicDialog
  const [showInactivePopup, setShowInactivePopup] = useState(false);
  const [showWeeklyActivePopup, setShowWeeklyActivePopup] = useState(false);
  const [showSingleDayPopup, setShowSingleDayPopup] = useState(false);
  const [showMultiDayPopup, setShowMultiDayPopup] = useState(false);
  
  // States for cancel subscription popups
  const [showCancelWeeklyPopup, setShowCancelWeeklyPopup] = useState(false);
  const [showCancelMultipleTimesPopup, setShowCancelMultipleTimesPopup] = useState(false);
  
  const handleButtonClick = (Option, chefOption) => {
    EnterOrderDetail(chefOption.subscribe_chef_id);
  };

  const AddSubscription = () => {
    navigate("/subscription-plans");
  };

  let navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await Promise.all([
          UserDetails(),
          routeTosignIn(),
          checksubcription(),
          SubscriptionPlan()
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [planName]);

  // Check for popup conditions
  useEffect(() => {
    // Check if user just completed a booking - don't show popups in that case
    const bookingCompleted = localStorage.getItem("booking_completed");
    if (bookingCompleted === "true") {
      // Clear the flag and don't show any popups
      localStorage.removeItem("booking_completed");
      setShowInactivePopup(false);
      setShowWeeklyActivePopup(false);
      setShowSingleDayPopup(false);
      setShowMultiDayPopup(false);
      return;
    }

    if (PlanList.length > 0 && !loading) {
      
      // 1. Check for inactive or no subscriptions
      const hasActivePlan = PlanList.some(plan => plan.status === "Active");
      if (!hasActivePlan) {
        setShowInactivePopup(true);
      } else {
        setShowInactivePopup(false);
      }
      
      // Check active plans for other popups
      const activePlans = PlanList.filter(plan => plan.status === "Active");
      
      // Reset other popups first
      setShowWeeklyActivePopup(false);
      setShowSingleDayPopup(false);
      setShowMultiDayPopup(false);
      
      activePlans.forEach(plan => {
        const isWeeklyPlan = plan.plan_name?.toLowerCase().includes("weekly");
        const isMultiplePlan = plan.plan_name?.toLowerCase().includes("multiple");
        
        // 2. Weekly Active Plan Popup
        if (isWeeklyPlan) {
          setShowWeeklyActivePopup(true);
        }
        
        // 3. Multiple Times with single day
        if (isMultiplePlan && plan.chef?.length === 1) {
          setShowSingleDayPopup(true);
        }
        
        // 4. Multiple Times with minimum two days
        if (isMultiplePlan && plan.chef?.length >= 2) {
          setShowMultiDayPopup(true);
        }
      });
      
    } else if (PlanList.length === 0 && !loading) {
      // No subscriptions at all
      setShowInactivePopup(true);
    }
  }, [PlanList, loading]);

  const checksubcription = async () => {
    try {
      let response = await fetch(
        `${process.env.REACT_APP_BASE_URL}subscription/check_current_plan`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: `${localStorage.getItem("logged_user_id")}`,
              "postal_code": `${localStorage.getItem("postalCode")}`
          }),
        }
      );
      const res_json = await response.text();
      const CurrentPlan = JSON.parse(res_json);

      if (CurrentPlan.status === true) {
        console.log(CurrentPlan);
        SetPlanData(CurrentPlan);
        setIsApiSuccess(true);
      } else {
        setIsApiSuccess(false);
        console.error("Error: Response status is false");
      }
    } catch (error) {
      console.error("Error while fetching data, please try later:", error);
    }
  };

  let SubscriptionPlan = async () => {
    try {
      let response = await fetch(
        `${process.env.REACT_APP_BASE_URL}subscription/fetch_subscription_chef`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: `${localStorage.getItem("logged_user_id")}`,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      let responseData = await response.json();
      console.log(responseData);
      if (responseData) {
        console.log(responseData);
        setPlans(responseData);
        setIsApiSuccess(true);
      } else {
        setIsApiSuccess(false); 
        console.error("Error: Response status is false");
      }
    } 
    catch (error) {
      console.error("Error fetching subscription data:", error);
    }
  };

  const UserDetails = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}user/loggedin_customer_detail`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: localStorage.getItem("logged_user_id") || "",
            email: localStorage.getItem("owner") || ""
          }),
        }
      );
      const res_json = await response.text();
      const userDetails = JSON.parse(res_json);

      if (userDetails.status === true) {
        const fetchedPostalCode = userDetails.data[0].postal_code;
        const fetchedAddress = userDetails.data[0].customer_address;

        console.log("Postal Code:", fetchedPostalCode);
        console.log("Address:", fetchedAddress);

        setPostalCode(fetchedPostalCode);
        setAddress(fetchedAddress);
        setIsApiSuccess(true);
      } else {
        setIsApiSuccess(false);
        console.error("Error: Response status is false");
      }
    } catch (error) {
      console.error("Error while fetching data, please try later:", error);
    }
  };

  const cancelSubscription = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}subscription/cancel_subscription_plan`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: localStorage.getItem("logged_user_id"),
          }),
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const res_json = await response.text();
      const data = JSON.parse(res_json);

      if (data.status === true) {
        localStorage.removeItem("subscription_id");
        if (postalCode) localStorage.setItem("postalCode", postalCode);
        if (address) localStorage.setItem("address", address);

        setPlanName(data.messages);
        console.log("Subscription canceled successfully!");

        // Call check_current_plan API after successful cancellation
        await fetch(
          `${process.env.REACT_APP_BASE_URL}/subscription/check_current_plan`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + getToken(),
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              user_id: `${localStorage.getItem("logged_user_id")}`,
              postal_code: `${localStorage.getItem("postalCode")}`,
            }),
          }
        );
        setimageDialog(false); // Close the loading dialog after API call completes

      } else {
        console.error("Error while canceling the subscription.");
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  // Helper function to check if plan is Weekly subscription
  const isWeeklyPlan = (planName) => {
    if (!planName) return false;
    const name = planName.toLowerCase();
    return name.includes('weekly') && !name.includes('multiple');
  };

  // Helper function to check if plan is Multiple Times subscription
  const isMultipleTimesPlan = (planName) => {
    if (!planName) return false;
    const name = planName.toLowerCase();
    return name.includes('multiple');
  };

  // Check if subscription is in commitment period
  const isInCommitmentPeriod = async () => {
    try {
      // First try to get data from PLanDetails (already loaded)
      let planData = PLanDetails;
      let planName = planData?.plan_name || '';
      
      // If PLanDetails doesn't have the data, fetch from API
      if (!planName || !planData.subscription_start_date) {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}subscription/check_current_plan`,
          {
            method: 'POST',
            headers: {
              'Authorization': 'Bearer ' + getToken(),
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              user_id: localStorage.getItem('logged_user_id'),
              postal_code: postalCode || localStorage.getItem("postalCode")
            }),
          }
        );
        // Use same parsing method as checksubcription function
        const res_text = await response.text();
        const res_json = JSON.parse(res_text);
        
        if (res_json.status) {
          planData = res_json;
          planName = res_json.plan_name || '';
        }
      }
      
      // Also try to get plan name from PlanList if still not available
      if (!planName && PlanList.length > 0) {
        const activePlan = PlanList.find(plan => plan.status === "Active");
        if (activePlan) {
          planName = activePlan.plan_name || '';
        }
      }
      
      // Check if we have subscription_start_date
      if (planData?.subscription_start_date) {
        const startDate = new Date(planData.subscription_start_date);
        const now = new Date();
        const weeksDiff = Math.floor((now - startDate) / (1000 * 60 * 60 * 24 * 7));
        
        const planNameLower = planName.toLowerCase();
        if (planNameLower.includes('weekly') && !planNameLower.includes('multiple')) {
          return weeksDiff < 3; // Weekly: 3 weeks commitment
        } else if (planNameLower.includes('multiple')) {
          return weeksDiff < 2; // Multiple Times: 2 weeks commitment
        }
      } else {
        // If subscription_start_date is not available, check if it's a subscription plan
        // and assume it's in commitment period if it's active
        const planNameLower = planName.toLowerCase();
        if (planData?.plan_status && (planNameLower.includes('weekly') || planNameLower.includes('multiple'))) {
          // If subscription is active and we don't have start date, assume it's in commitment period
          // This is a fallback - ideally the API should provide subscription_start_date
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error('Error checking commitment period:', error);
      // Fallback: if it's a subscription plan, assume it's in commitment period
      const planName = (PLanDetails?.plan_name || '').toLowerCase();
      if (PLanDetails?.plan_status && (planName.includes('weekly') || planName.includes('multiple'))) {
        return true;
      }
      return false;
    }
  };

  let cancelConfirmationSubscription = async () => {
    // Get plan name from PLanDetails first
    let planName = PLanDetails?.plan_name || '';
    
    // If not available, try to get from PlanList
    if (!planName && PlanList.length > 0) {
      const activePlan = PlanList.find(plan => plan.status === "Active");
      planName = activePlan?.plan_name || '';
    }
    
    console.log('Cancel subscription - Plan Name:', planName);
    console.log('PLanDetails:', PLanDetails);
    
    // Check if in commitment period
    const inCommitment = await isInCommitmentPeriod();
    console.log('In Commitment Period:', inCommitment);
    
    if (inCommitment) {
      // Show appropriate popup based on plan type
      if (isWeeklyPlan(planName)) {
        console.log('Showing Weekly cancel popup');
        setShowCancelWeeklyPopup(true);
      } else if (isMultipleTimesPlan(planName)) {
        console.log('Showing Multiple Times cancel popup');
        setShowCancelMultipleTimesPopup(true);
      } else {
        // Fallback to old dialog if plan type not recognized
        console.log('Plan type not recognized, showing old dialog');
        setOpenDialog(!openDialog);
      }
    } else {
      // Not in commitment period, proceed with cancellation directly
      console.log('Not in commitment period, showing old dialog');
      setOpenDialog(!openDialog);
    }
  };

  const changeScreen = () => {
    cancelSubscription();
    setOpenDialog(false);
    setShowCancelWeeklyPopup(false);
    setShowCancelMultipleTimesPopup(false);
    setPlanName("");
    setimageDialog(true);
  };

  const changeScreenSecondButton = () => {
    navigate("/subscription-plans");
  };

  const handleNavigate = () => {
    navigate("/chef-list");
  };

  const EnterOrderDetail = (chef_id) => {
    localStorage.setItem("chef_id", chef_id);
    navigate("/booking-detail");
  };

  const routeTosignIn = async () => {
    if((localStorage.getItem("role"))){
      console.log('display Play List');
    }else{
      navigate("/sign-in");
    }
  };

  // Consent texts for cancel subscription
  const cancelWeeklyText = `I acknowledge that if I cancel subscription during the committment period of first two (2) consecutive weeks, I agree to pay a cancellation charge of $50.`;

  const cancelMultipleTimesText = ` I acknowledge that if I cancel subscription during the committment period of first two (2) consecutive weeks, I agree to pay a cancellation charge of $50.`;

  return (
    <>
      {/* Popup 1: Inactive or No Subscriptions */}
      <DynamicDialog
        getDialog={2}
        imagesrc={""}
        openDialog={showInactivePopup}
        title={"Please Click \"Select Pricing\" to select your Plan"}
        buttonText={"OK"}
        showSecondButton={false}
        changeScreen={() => setShowInactivePopup(false)}
        closeDialog={(value) => {
          setShowInactivePopup(value);
        }}
      />

      {/* Popup 2: Weekly Active Plan */}
      <DynamicDialog
        getDialog={2}
        imagesrc={""}
        openDialog={showWeeklyActivePopup}
        title={"Please click Enter Order Details to send your weekly booking to your Home Chef for discounted rate."}
        buttonText={"OK"}
        showSecondButton={false}
        changeScreen={() => setShowWeeklyActivePopup(false)}
        closeDialog={(value) => {
          setShowWeeklyActivePopup(value);
        }}
      />

      {/* Popup 3: Multiple Times - Single Day */}
      <DynamicDialog
        getDialog={2}
        imagesrc={""}
        openDialog={showSingleDayPopup}
        title={"You have subscribed Home Chef for One day of the week. Please click \"Select More Day for the week\" to subscribe Chef again for another day of the week, before you enter Order Details."}
        buttonText={"OK"}
        showSecondButton={false}
        changeScreen={() => setShowSingleDayPopup(false)}
        closeDialog={(value) => {
          setShowSingleDayPopup(value);
        }}
      />

      {/* Popup 4: Multiple Times - Minimum Two Days */}
      <DynamicDialog
        getDialog={2}
        imagesrc={""}
        openDialog={showMultiDayPopup}
        title={"Please click Enter Order to send your booking to your Home Chef for discounted rate."}
        buttonText={"OK"}
        showSecondButton={false}
        changeScreen={() => setShowMultiDayPopup(false)}
        closeDialog={(value) => {
          setShowMultiDayPopup(value);
        }}
      />

      
        <DynamicDialog
          openDialog={openaddDialog}
          title={
            !PLanDetails.chef_status && PLanDetails.plan_status
              ? `${PLanDetails.plan_name} \nYour Chef is not added. Please add a chef`
              : "Do you want to view and add a new subscription plan?"
          }
          buttonText={"Yes"}
          showSecondButton={false}
          changeScreen={() => AddSubscription()}
          closeDialog={(value) => {
            setOpenaddDialog(value);
          }}
        />

        {imageDialog ? (
          <DynamicDialog
            getDialog={1}
            imagesrc={smile}
            openDialog={!openDialog}
            title={planName}
            
            buttonText={"Cancel Subscription"}
            showSecondButton={true}
            changeScreen={() => changeScreen()}
            secondButtonText={"Select Another Plan"}
            changeScreenSecondButton={() => changeScreenSecondButton()}
            closeDialog={(value) => {
              setimageDialog(value);
            }}
          />
        ) : (
          <DynamicDialog
            getDialog={2}
            imagesrc={""}
            openDialog={openDialog}
            title={"Do you want to cancel subscription?"}
            buttonText={"Yes"}
            showSecondButton={true}
            changeScreen={() => changeScreen()}
            secondButtonText={"No"}
            changeScreenSecondButton={() => setOpenDialog(!openDialog)}
            closeDialog={(value) => {
              setOpenDialog(value);
            }}
          />
        )}

      {/* Cancel Weekly Subscription Popup */}
      <SubscriptionConsentDialog
        isOpen={showCancelWeeklyPopup}
        onClose={() => setShowCancelWeeklyPopup(false)}
        consentText={cancelWeeklyText}
        onAgree={async () => {
          setShowCancelWeeklyPopup(false);
          await cancelSubscription();
          setPlanName("");
          setimageDialog(false);
        }}
        buttonText="Agree"
      />

      {/* Cancel Multiple Times Subscription Popup */}
      <SubscriptionConsentDialog
        isOpen={showCancelMultipleTimesPopup}
        onClose={() => setShowCancelMultipleTimesPopup(false)}
        consentText={cancelMultipleTimesText}
        onAgree={async () => {
          setShowCancelMultipleTimesPopup(false);
          await cancelSubscription();
          setPlanName("");
          setimageDialog(false);
        }}
        buttonText="Agree"
      />

        {
          <div className="container">
            <p className="mt-2 mb-0 text-center">Subscription Summary</p>

            {loading ? (
              <div className="text-center mt-5 py-5">
                <div className="spinner-border text-orange" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading subscriptions...</p>
              </div>
            ) : PlanList.length > 0 ? (
              <>
                <div className="mobile new-design-card mt-3">
                  <div
                    style={{
                      display: !PLanDetails.chef_status ? "block" : "none",
                    }}
                  >
                    <div
                      style={{
                        paddingTop: "5px",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                     <button
  type="button"
  onClick={AddSubscription}
  style={{
    whiteSpace: "pre-wrap",
    textAlign: "center",
    marginTop: "7px",
    marginBottom: "3px",
    marginRight: "6px",
    color: "#fff",
    backgroundColor: "#ff5e41",
    cursor: "pointer",
    fontSize: "0.9rem",
    border: "none",
    borderRadius: "50PX",
    padding: "6px 12px",
    //fontWeight: "bold",
  }}
>
   Select Pricing
</button>

                    </div>
                  </div>
                  <div className="row">
                    {PlanList.map((option, index) => (
                      <div className="col-md-4 col-sm-12" key={index}>
                        <div
                          className="border row border-1 m-1 py-2"
                          style={{
                            borderRadius: "20px",
                            boxShadow: "0 0 0 rgba(0,0,0,0.2)", // Corrected boxShadow syntax
                          }}
                        >
                          <div className="row">
                            <div>
                              <span
                                className="badge text-wrap"
                                style={{
                                  borderRadius: "20px",
                                  color: "white",
                                  backgroundColor:
                                    option.status === "Active"
                                      ? "#4dff4d"
                                      : "red", // Simplified the static backgroundColor
                                }}
                              >
                                {option.status}
                              </span>

                              <span
                                className="badge text-wrap"
                                style={{
                                  borderRadius: "20px",
                                  marginLeft: "10px",
                                  color: "white",
                                  backgroundColor: `${option.color_code}`,
                                }}
                              >
                                {option.plan_name}
                              </span>
                            </div>

                            <div className="row my-2">
                              <p className="pl-4 mb-0">
                                Subscription ID: {option.subscription_no}
                              </p>
                            </div>
                            {option.chef.map((chefData, ChefIndex) => (
                              <div className="chef-new-card" key={ChefIndex}>
                                <div className="row">
                                  <div className="col-md-2 col-2">
                                    <div
                                      className="d-flex justify-content-center align-items-center my-2"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                      }}
                                    >
                                      <img
                                        src={
                                          chefData.booking_by_user_profile_image
                                            ? chefData.booking_by_user_profile_image
                                            : profile
                                        }
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                          borderRadius: "50%",
                                        }}
                                        alt="Profile"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-10 col-10 d-flex align-items-center">
                                    <h6 className="fw-bold">
                                      {chefData.chef_name}
                                    </h6>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-2 col-2">
                                    <button
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        border: "1px solid #FF5E41",
                                        cursor: "pointer",
                                        backgroundColor: "#FF5E41",
                                      }}
                                      className="px-1"
                                      onClick={() => {
                                        console.log(option.chef.length);
                                        navigate("/subscription-message", {
                                          state: {
                                            data: {
                                              plan_id: option.plan_id,
                                              plan_name: option.plan_name,
                                              color_code: option.color_code,
                                              image: chefData.profile_image,
                                              name: chefData.chef_name,
                                              subscription_status:
                                                chefData.status,
                                              customer_id: chefData.user_id,
                                              chef_id:
                                                chefData.subscribe_chef_id,
                                            },
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={chatBubble}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </button>
                                  </div>
                                  <div className="col-md-10 col-10">
                                    <div className="row my-2">
                                      <div className="col-1">
                                        <p className="p-0 mb-0">
                                          <IoMdStopwatch
                                            style={{
                                              fontSize: "1.2rem",
                                            }}
                                          />
                                        </p>
                                      </div>
                                      <div className="col-10">
                                        <p
                                          className="p-0 m-0"
                                          style={{ fontSize: "0.9rem" }}
                                        >
                                          Every {chefData.timeslot}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="row my-2">
                                      <div className="col-1">
                                        <p className="p-0 mb-0">
                                          <MdOutlineAttachMoney
                                            style={{ fontSize: "1.2rem" }}
                                          />
                                        </p>
                                      </div>
                                      <div className="col-10 text-break">
                                        <p
                                          className="mb-0"
                                          style={{
                                            fontSize: "0.9rem",
                                            paddingTop: "0.1rem",
                                          }}
                                        >
                                          {chefData.price}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="button-container">
                                  <div style={{ position: "relative" }}>
                                    <button
                                      className="px-1 container-button"
                                      style={{
                                        width: "140px",
                                        fontSize: "0.7rem",
                                        pointerEvents:
                                        option?.enter_order_details === true
                                          ? false // Enabled when true
                                          : true // Disabled when null, undefined, or false
                                          ? "none"
                                          : "auto",
                                      opacity:
                                        option?.enter_order_details === true
                                          ? false // Enabled when true
                                          : true // Disabled when null, undefined, or false
                                          ? 0.6
                                          : 1,
                                      }}
                                      onClick={() => {
                                        localStorage.setItem(
                                          "subscription_id",
                                          chefData.subscription_id
                                        );
                                        handleButtonClick(
                                          option.chef,
                                          chefData
                                        );
                                      }}
                                      disabled={
                                        option?.enter_order_details === true
                                          ? false // Enabled when true
                                          : true // Disabled when null, undefined, or false
                                      }

                                    
                                    >
                                      Enter Order Details
                                    </button>
                                  </div>

                    
                                </div>
                                {ChefIndex < option.chef.length - 1 && (
                                  <hr style={{ marginBottom: "5px" }} />
                                )}
                              </div>
                            ))}
                            {option.status === "Active" &&
                              option.max_dates > option.chef.length && (
                                <div className="select one more day text-center">

                              {/*Shivansh Dubey*/}
                                  <a
                                    role="button"
                                    onClick={() => handleNavigate()}
                                    style={{
                                      whiteSpace: "pre-wrap",
                                      textAlign: "center",
                                      marginTop: "7px",
                                      marginBottom: "3px",
                                      marginRight: "6px",
                                      color: "#ef492cff",
                                      cursor: "pointer",
                                      fontSize: "0.7rem",
                                    }}
                                  >
                                   <strong> + CLICK to Select More Days For The Week </strong>
                                  </a>
                               
                                </div> 

                              )}
                          </div>
                        </div>
                        
                        <div>
                          {option.status === "Active" &&
                            option.min_dates > option.chef.length && (
                              <div
                                style={{
                                  color: "#FF5E41",
                                  marginBottom: "5px",
                                  marginLeft: "10px",
                                  textAlign: "center",
                                }}
                              >
                                <span style={{ fontSize: "0.8rem" }}>
                                  Please select minimum two days in a week before you click 'Enter Order Details.
                                </span>
                              </div>
                            )}
                        </div>

                        <div
                          style={{
                            paddingTop: "5px",
                            textAlign: "center",
                            display:
                              option.status === "Active" ? " block" : "none",
                          }}
                        > 
                          <p
                            style={{
                              fontSize: "0.68rem",
                              color: "red",
                              marginBottom: "10px",
                              lineHeight: "1.5",
                              maxWidth: "500px",
                              textAlign: "center"
                            }}
                          >
                            I agree to book chefs introduced through Chef Republic for any services, on the platform as outlined in the <a href="/chef/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                              Terms & Conditions
                            </a>.
                          </p>
                          <button
                            className="px-1 container-button mb-3"
                            style={{ width: "150px", fontSize: "0.7rem" }}
                            onClick={() => cancelConfirmationSubscription()}
                            disabled={
                              option.status === "Inactive" ||
                              option.min_dates > option.chef.length
                            }
                          >
                            Cancel Subscription
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="App text-start">
                  <div
                    style={{
                      display: !PLanDetails.chef_status ? "block" : "none",
                    }}
                  >
                    <div
                      style={{
                        paddingTop: "5px",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        className="px-1 container-button"
                        style={{ width: "140px", fontSize: "0.7rem" }}
                        onClick={() => AddSubscription()}
                      >
                        Select Pricing
                      </button>
                    </div>
                  </div>

                  {isApiSuccess &&
                    PlanList.length > 0 &&
                    PlanList.map((option, index) => (
                      <div key={index} className="row my-2 ">
                        <div
                          className="p-3 "
                          style={{
                            borderRadius: "20px",
                            border: "1px solid #dee2e6",
                          }}
                        >
                          <div className="mb-3">
                            <span style={{ marginRight: "20px" }}>
                              Subscription ID: {option.subscription_no}{" "}
                            </span>
                            <span
                              className="badge "
                              style={{
                                borderRadius: "20px",
                                color: "white",
                                backgroundColor:
                                  option.status === "Active"
                                    ? "#4dff4d"
                                    : "red", // Simplified the static backgroundColor
                              }}
                            >
                              {option.status}
                            </span>
                            <span
                              className="badge"
                              style={{
                                borderRadius: "20px",
                                marginLeft: "10px",
                                color: "white",
                                backgroundColor: `${option.color_code}`, // Simplified the static backgroundColor
                              }}
                            >
                              {option.plan_name}
                            </span>
                          </div>

                          {option.chef.map((chefOption, chefIndex) => (
                            <div
                              key={chefIndex}
                              className="row me-2 my-2"
                              style={{
                                justifyContent: "start",
                                display: "flex",
                              }}
                            >
                              <div
                                className="col-md-3"
                                style={{ borderRight: "2px solid black" }}
                              >
                                <div className="chef-name">
                                  <img
                                    src={
                                      chefOption.booking_by_user_profile_image
                                        ? chefOption.booking_by_user_profile_image
                                        : profile
                                    }
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      marginRight: "10px",
                                    }}
                                    alt="Profile"
                                  />
                                  <span>{chefOption.chef_name}</span>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="chef-time mt-2">
                                  <TfiTimer size={20} />
                                  <span className="ms-2">
                                    Every {chefOption.timeslot}{" "}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div
                                  className="row chef-button"
                                  style={{ borderRight: "2px solid black" }}
                                >
                                  <div className="col-md-10 text-center">
                                    <button
                                      className="px-1 container-button"
                                      style={{
                                        width: "140px",
                                        fontSize: "0.7rem",

                                        pointerEvents:
                                          option?.enter_order_details === true
                                            ? false // Enabled when true
                                            : true // Disabled when null, undefined, or false
                                            ? "none"
                                            : "auto",
                                        opacity:
                                          option?.enter_order_details === true
                                            ? false // Enabled when true
                                            : true // Disabled when null, undefined, or false
                                            ? 0.6
                                            : 1,
                                      }}
                                      onClick={() => {
                                        localStorage.setItem(
                                          "subscription_id",
                                          chefOption.subscription_id
                                        );
                                        handleButtonClick(
                                          option.chef,
                                          chefOption
                                        );
                                      }}
                                      disabled={
                                        option?.enter_order_details === true
                                          ? false // Enabled when true
                                          : true // Disabled when null, undefined, or false
                                      }
                                    >
                                      Enter Order Details
                                    </button>
                                  </div>
                       
                                  <div className="col-md-2">
                                    <button
                                      className="px-1 container-button"
                                      onClick={() => {
                                        console.log(option.chef.length);
                                        navigate("/subscription-message", {
                                          state: {
                                            data: {
                                              // status: option,
                                              plan_id: option.plan_id,
                                              plan_name: option.plan_name,
                                              color_code: option.color_code,
                                              image: chefOption.profile_image,
                                              name: chefOption.chef_name,
                                              subscription_status:
                                                chefOption.status,
                                              customer_id: chefOption.user_id,
                                              chef_id:
                                                chefOption.subscribe_chef_id,
                                            },
                                          },
                                        });
                                      }}
                                    >
                                      <img
                                        src={chatBubble}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <div
                                  className="px-1 mt-2"
                                  style={{
                                    backgroundColor: "#FFFFFF",
                                    color: "#000000",
                                  }}
                                >
                                  ${option.price}
                                </div>
                              </div>
                            </div>
                          ))}
                          <div className="below_button">
                            {option.status === "Active" &&
                              option.max_dates > option.chef.length && (
                                <div className="row text-center">
                                  <div className="mb-3">
                                    <button
                                      className="px-2 container-button"
                                      style={{ fontSize: "0.7rem" }}
                                      onMouseEnter={() => setIsHovered(true)}
                                      onMouseLeave={() => setIsHovered(false)}
                                      onClick={() => handleNavigate()}
                                    >
                                      {isHovered ? (
                                        <span style={{ fontSize: "0.7rem" }}>
                                          + Select One More Day For The Week
                                        </span>
                                      ) : (
                                        <span
                                          className="px-3"
                                          style={{ fontSize: "0.8rem" }}
                                        >
                                          +
                                        </span>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                        <div>
                          {option.status === "Active" &&
                            option.min_dates > option.chef.length && (
                              <div
                                style={{
                                  color: "#FF5E41",
                                  marginBottom: "5px",
                                }}
                              >
                                <span style={{ fontSize: "0.9rem" }}>
          Please select minimum two days in a week before you click 'Enter Order Details'
        </span>
                              </div>
                            )}
                        </div>
                        <div
                          style={{
                            paddingTop: "5px",
                            display:
                              option.status === "Active" ? " block" : "none",
                          }}
                        >
                          <p
                            style={{
                              fontSize: "0.68rem",
                              color: "red",
                              marginBottom: "10px",
                              lineHeight: "1.5",
                              maxWidth: "900px",
                              textAlign: "left"
                            }}
                          >
                            I agree to book chefs introduced through Chef Republic for any services, on the platform as outlined in the <a href="/chef/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                              Terms & Conditions
                            </a>.
                          </p>
                          <button
                            className="px-1 container-button"
                            style={{ width: "140px", fontSize: "0.7rem" }}
                            onClick={() => cancelConfirmationSubscription()}
                          >
                            Cancel Subscription
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    paddingTop: "5px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    className="px-1 container-button"
                    style={{ width: "140px", fontSize: "0.7rem" }}
                    onClick={() => AddSubscription()}
                  >
                    Select Pricing
                  </button>
                </div>
                <div className="text-center mt-5">
                  <p>You Do Not Have Any Subscriptions Yet</p>{" "}
                  {/* Show if no plans after successful API */}
                </div>
              </>
            )}
          </div>
        }
      </>
    );
  }
  
  export default SubscriptionSummary;
